export default __webpack_public_path__ + "static/Leaf5-a5080e27feccec6dcdb6795793358068.png";